import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, MaybeAsync, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { Tenant } from '@models/module/tenant';
import { TenantStore, UserStore } from '@signal-store';

@Injectable({
  providedIn: 'root',
})
export class TenantGuard implements CanActivate {
  tenantStore = inject(TenantStore);
  userStore = inject(UserStore);
  router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot): MaybeAsync<boolean> {
    const potentialTenant = next.params['tenantId'].toLowerCase();

    const checkTenant = (tenant: Tenant) => {
      return tenant.name.toLowerCase() === potentialTenant;
    };

    // if there is a selectedTenant:
    const currentTenant = this.tenantStore.selectedTenant();
    if (currentTenant && checkTenant(currentTenant)) {
      return true;
    }

    // if the availableTenants are loaded
    const selectCurrentTenant = (availableTenants: Tenant[]) => {
      const selectedTenant = availableTenants.find(checkTenant);
      if (selectedTenant) {
        // set the selected tenant in the store
        this.tenantStore.selectTenant(selectedTenant);
        // load the user before activating the route
        this.userStore.setUser();
        return true;
      }

      this.router.navigate(['/']);
      return false;
    };

    const availableTenants = this.tenantStore.availableTenants();
    if (availableTenants?.length) {
      return selectCurrentTenant(availableTenants);
    } else {
      return this.tenantStore.loadTenants().pipe(
        map(availableTenants => selectCurrentTenant(availableTenants)),
        take(1),
      );
    }
  }
}
